<template>
  <section class="checkout-section">
    <div class="checkout-section__header checkout-section__header--no-line">
      <h2 class="checkout-section__title">{{data.passengerDetails.title}}</h2>
      <div class="checkout-section__description" v-html="data.passengerDetails.descriptionHtml"></div>
    </div>

    <Login v-if="isLoginBoxDisplayed" />

    <Passenger
      v-else
      v-for="(passenger, index) in passengers"
      :key="passenger.passengerId"
      :passenger="passenger"
      :index="index"
    />

    <PriceBreakdown :usePassengerDetails="true" />

    <Payment :brandName="data.brandNameFormatted" />

    <div v-if="hasDuplicateName" class="error-message passenger__name-error">
      <div class="error-message__icon"></div>
      <div class="error-message__text">
        <p>You cannot continue with two passengers of the same name</p>
      </div>
    </div>

    <div class="checkout-section__footer">
      <NavButton
        :class="{ 'btn btn--outline-gray-color btn--outline-gray-color_sm js-modal resultCardMapTs': data.brandNameFormatted === Brand.Travelsphere }"
        :back="true"
        text="Back"
        :stepBackAmount="excursionsVisited && !excursionsExist ? 2 : 1"
      />
      <NavButton text="Continue to book" :disabled="!canBook" @beforeNextStep="book" />
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Login from './../Components/Login.vue';
import Passenger from './../Components/Passenger.vue';
import PriceBreakdown from './../Components/PriceBreakdown.vue';
import Payment from './../Components/Payment.vue';
import NavButton from './../Components/NavButton.vue';
import {Brand} from './../../../../brand.js';

export default {
  name: 'PassengerDetails',

  components: {
    Login,
    Passenger,
    PriceBreakdown,
    Payment,
    NavButton
  },

  data: function() {
    return {
      Brand
    };
  },

  computed: {
    ...mapState('checkout', [
      'passengers',
      'payment',
      'quote',
      'paymentLoading',
      'data',
      'excursionData',
      'excursionsExist',
      'excursionsVisited',
      'isLoginBoxDisplayed',
      'loggedInPassengerData'
    ]),
    ...mapGetters('checkout', [
      'firstIncompletePassenger',
      'allPassengersComplete',
      'isReservation',
      'passengersDetails',
      'currentStepName',
      'passengersHaveMobilityLimitations'
    ]),
    ...mapGetters(['formIsValid']),

    /** we can book if passengers are valid and payment is selected and has been submitted */
    canBook() {
      return (
        !this.firstIncompletePassenger &&
        this.payment &&
        this.formIsValid(this.payment) &&
        this.payment.hasBeenSubmitted &&
        !this.hasDuplicateName
      );
    },

    hasDuplicateName() {
      return this.$store.getters['checkout/passengerHasDuplicateName'](
        this.passengersDetails
      );
    }
  },

  watch: {
    isLoginBoxDisplayed(isLoginBoxDisplayed) {
      if (!isLoginBoxDisplayed) {
        this.$store.commit('checkout/setPassengersFromQuote');
      }
    },
    allPassengersComplete(allPassengersComplete) {
      if (!allPassengersComplete) {
        this.$store.commit('checkout/resetPayment');
      }
    }
  },

  activated() {
    if (this.data.login.userIsLoggedIn && this.loggedInPassengerData) {
      this.$store.commit('checkout/setIsLoginBoxDisplayed', false);
    } else if (!this.isLoginBoxDisplayed) {
      this.$store.commit('checkout/setPassengersFromQuote');
    }
  },

  methods: {
    book() {
      var dataLayerItem = JSON.parse(JSON.stringify({
          passengers: this.passengers,
          brand: this.data.brand,
          quote: this.quote,
          payment: this.payment,
          payment_type: this.getCardName(),
          data: this.$store.state.checkout
        }));
      
      GTM.bookingPurchaseSubmit(dataLayerItem);

      if (this.isReservation) {
        this.$store.dispatch('checkout/confirmBooking');
        this.$store.commit('checkout/nextStep');
      } else {
        this.$store.dispatch('checkout/payment');
      }
    },

    getCardName() {
      if (this.payment.data.cardTypes.length === 0) {
        return 'Unknown card type';
      }
      
      return this.payment.data.cardTypes.find(
        card => card.id === this.payment.fields.cardTypeId.value
      ).name;
    },

    toggleTakeFinalBalance() {
      this.$store.commit("checkout/toggleTakeFinalBalance");
    },
  }
};
</script>
